var _require = require('@antv/util'),
    mix = _require.mix;

module.exports = {
  assign: mix
};